import { OrganizationTypes } from '@/common/constants';
import Permissions from '@/common/permissions';
import { useHasAccess } from '@/modules/core/hooks';

export const useEmployerTerminationReactivationAccess = () => {
  const hasAccessTerminateEmployer = useHasAccess([
    { organizationType: OrganizationTypes.system },
    {
      organizationType: OrganizationTypes.partner,
      permission: Permissions.ACTIVATE_ER,
    },
    {
      organizationType: OrganizationTypes.distributor,
      permission: Permissions.ACTIVATE_ER,
    },
  ]);

  const hasAccessReactivateEmployer = useHasAccess([
    { organizationType: OrganizationTypes.system },
    {
      organizationType: OrganizationTypes.partner,
      permission: Permissions.REACTIVATE_EMPLOYER,
    },
    {
      organizationType: OrganizationTypes.distributor,
      permission: Permissions.REACTIVATE_EMPLOYER,
    },
  ]);

  return {
    hasAccessTerminateEmployer,
    hasAccessReactivateEmployer,
  };
};